var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 margin-bottom-15 margin-left-15"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go back")])]),_c('div',{staticClass:"col-12"},[_c('EnglishCentralGame',{attrs:{"dialog":_vm.dialog}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }